import { FC } from 'react';
import classes from './EntityActionPanel.module.scss';

interface EntityActionPanelProps {
    name: string;
    children?: React.ReactNode;
    buttons?: React.ReactNode;
    variant?: 'default' | 'primary' | 'success' | 'warning';
}

/** Показывает заголовок и действия раздела */
export const EntityActionPanel: FC<EntityActionPanelProps> = (props) => {
    const { name, children, buttons, variant = 'default' } = props;

    const panelClass = `${classes.entityActionPanel} ${classes[`variant--${variant}`]}`;

    return (
        <div
            id="entityActionPanel"
            className={panelClass}
        >
            <div className={classes.titleRowWrapper}>
                <h1 className={classes.entityTitle}>{name || ''}</h1>
                <div className={classes.buttonsWrapper}>{buttons}</div>
            </div>
            {children}
        </div>
    );
};